import { useEffect, useState } from 'react';
import axios from 'axios';
import { Box, Spinner, Text } from '@chakra-ui/react';
import { useData } from '../../data';
import moment from 'moment';

const Trends = ({ filterFeeds }) => {
  const { data, isLoading, refetch } = useData(`feed/trends`, 10000);
  const [trends, setTrends] = useState([]);
  const [news, setNews] = useState([]);
  const { data: newsData, isLoading: isLoadingNews, refetch: refetchNews } = useData(
    `news?page_no=1`,
);

  useEffect(() => {
    if (data?.data?.trends?.length > 0) {
      setTrends(data?.data?.trends);
    }
  }, [data]);

  useEffect(() => {
    if (newsData?.data?.news?.length > 0) {
      setNews(newsData?.data?.news);
    }
  }, [newsData]);

  return (
    <div className='flex flex-col gap-5'>
    <div className="bg-white rounded-lg p-4 w-full max-w-sm">
      <Text className="text-lg font-bold">What's Happening</Text>

      {isLoading ? (
        <Box className='flex w-full py-3 justify-center'>
          <Spinner size={'sm'} />
        </Box>
      ) : trends.length === 0 ? (
        <Box className="py-14">
          <Text className="text-sm text-gray-700 text-center">
            No trends to show
          </Text>
        </Box>
      ) : (
        <Box className="py-5">
          <ul className="space-y-2">
            {trends.map((trend, index) => (
              <li
                onClick={() => filterFeeds(trend.category)}
                key={index}
                className="cursor-pointer flex justify-between items-center px-3 py-2 bg-gray-50 rounded hover:bg-gray-100 transition"
              >
                <span className="text-sm text-gray-700">{trend.category}</span>
                <span className="text-xs bg-gray-200 text-gray-700 px-2 py-0.5 rounded-full">
                  {trend.post_count} posts
                </span>
              </li>
            ))}
          </ul>
        </Box>
      )}
    </div>

    <div className="bg-white shadow-md rounded-lg p-4 w-full max-w-sm">

      <Text className="text-lg pb-4 font-bold">Seed A Founder News</Text>

      {isLoadingNews ? (
          <Box className='flex w-full py-3 justify-center'>
            <Spinner size={'sm'} />
          </Box>
        ) : news.length > 0 ? (
          <Box className="pb-5">
            <ul className="space-y-2">
              {news.map((item, index) => (
                <Box className={`hover:bg-gray-50 ${index == news.length - 1 ? 'border-b-0' : 'border-b'}  py-2 px-3`} key={item.id}>
                  <a className='text-black hover:no-underline' href={item.url} target="_blank">
                    <Text className="font-medium">{item.title}</Text>
                    <Box className='w-full flex flex-col gap-1'> 
                      <Text className="text-sm text-gray-700">{item.description}</Text>
                      <Text className="text-xs text-gray-700 capitalize">{moment(item?.createdAt).fromNow()}</Text>
                    </Box>
                  </a>
                </Box>
              ))}
            </ul>
          </Box>
        ) : (
          <Box className="py-14">
            <Text className="text-sm text-gray-700 text-center">
              No news to show
            </Text>
          </Box>
        )}

    </div>
    </div>
  );
};

export default Trends;
